<div>
  <strong>{{item.translation_key_label||item.label| translation|translationFromString | transformText :item?.text_transform_label}}</strong>
  <div *ngIf="item.instructions">{{item.translation_key_instructions||item.instructions| translation|translationFromString | transformText :item?.text_transform_key}}</div>
</div>
<nb-tabset>
  <nb-tab [tabTitle]="'from_url'| translation">
      <nb-form-field [ngClass]="{'mat-form-field-invalid':item.notvalid,'ng-invalid':this.item.notvalid}" style="width:80%" >
        <label for=" url">URL</label>
        <input nbInput type="url" [placeholder]="'configuration_url'| translation" [(ngModel)]="url" name="url" fullWidth="true"/>
      </nb-form-field>
      <button nbButton (click)="getSettings()">{{'configuration_get'| translation}}</button>
  </nb-tab>
  <nb-tab [tabTitle]="'from_xml'| translation">
      <div>
        <label for="input">XML</label>
        <textarea style="height:200px;width:100%;" [(ngModel)]="input" nbInput fullWidth="true" name="input"></textarea>
      </div>
      <button nbButton (click)="dataInput()">{{'configuration_process'| translation}}</button>
  </nb-tab>
</nb-tabset>
